import {inject, Injectable} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';

/**
 * Central accessor for outbound marketing URLs whose target depends on the active language.
 *
 * The URLs live in the always-loaded root translation (`externalUrls.*`) so there is a single
 * localized source of truth shared by the navbar, the select-property page and the checkout.
 */
@Injectable({providedIn: 'root'})
export class ExternalUrlsService {
  private readonly transloco = inject(TranslocoService);

  /** Marketing site entry point used to start a new document request (package selection). */
  newRequestUrl(): string {
    return this.transloco.translate('externalUrls.newRequest');
  }
}
